import {styled} from '../../utils';
import {hideVisually} from 'polished';

export default styled('input')(hideVisually());



// WEBPACK FOOTER //
// ./src/components/GhostInput/GhostInput.tsx